import { Agency } from "@adgate/common/types/agency.type";
import { BaseObject } from "@adgate/common/types/base-object.type";
import { Category } from "@adgate/common/types/category.type";
import { ChannelFamily } from "@adgate/common/types/channel-family.type";
import { CommercialOffice } from "@adgate/common/types/commercial-office.type";
import { CommercialType } from "@adgate/common/types/commercial-type.type";
import { Language } from "@adgate/common/types/language.type";

export class CommercialFilter
{
    id!: number;
    brand: string = "";
    product: string = "";
    version: string = "";
    referenceCode: string = "";
    createdFrom: number | null = null;
    createdTo: number | null = null;
    office: CommercialOffice[] = [];
    agency: Agency[] = [];
    channelFamily: ChannelFamily[] = [];
    language: Language[] = [];
    category: Category[] = [];
    type: CommercialType[] = [];
    status: BaseObject[] = [];
    limit: number = 100;
  }